import { render, staticRenderFns } from "./input-tags.vue?vue&type=template&id=40d44aa1&"
import script from "./input-tags.vue?vue&type=script&lang=js&"
export * from "./input-tags.vue?vue&type=script&lang=js&"
import style0 from "./input-tags.vue?vue&type=style&index=0&id=40d44aa1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports